import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const VoucherSection = "/reports/bi/voucher";

export const VoucherListPath = VoucherSection;

export enum VoucherReportsListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType"
}

export enum VoucherReportsListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand"
}

export type VoucherReportsListUrlDialog = "download" | TabActionDialog;
export type VoucherReportsListUrlFilters = Filters<
  VoucherReportsListUrlFiltersEnum
> &
  FiltersWithMultipleValues<VoucherReportsListUrlFiltersWithMultipleValues>;

export type VoucherReportsUrlQueryParams = ActiveTab &
  VoucherReportsListUrlFilters &
  BulkAction &
  Dialog<VoucherReportsListUrlDialog> &
  Pagination &
  SingleAction;
export const voucherReportsListUrl = (params?: VoucherReportsUrlQueryParams) =>
  VoucherListPath + "?" + stringifyQs(params);
